export default __webpack_public_path__ + "static/media/TBT0228_Dignity_at_Work.6c40a6ed.pdf";